import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import type { ReactNode } from "react";
import { useState } from "react";

const FLOATING_BUTTON_STACK_OFFSET = 72;

interface FloatingNotificationButtonProps {
  ariaLabel: string;
  label: string;
  icon: ReactNode;
  onClick: () => void;
  stackIndex: number;
}

export const FloatingNotificationButton = ({
  ariaLabel,
  label,
  icon,
  onClick,
  stackIndex,
}: FloatingNotificationButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseLeave37 = useStableCallback(() => setIsHovered(false));

  const handleMouseEnter36 = useStableCallback(() => setIsHovered(true));

  const handleFocus35 = useStableCallback(() => setIsHovered(true));

  const handleBlur33 = useStableCallback(() => setIsHovered(false));

  return (
    <div
      className="fixed right-6 bottom-6 z-50 transition-transform duration-500 [transition-timing-function:cubic-bezier(0.34,1.56,0.64,1)]"
      style={{
        transform: `translateY(${String(-stackIndex * FLOATING_BUTTON_STACK_OFFSET)}px)`,
      }}
    >
      <button
        aria-label={ariaLabel}
        className="floating-corner-button-in bg-bzd-button hover:bg-bzd-button-hover focus:ring-bzd-purple-300 flex items-center gap-2 overflow-hidden rounded-full text-white shadow-lg transition-all duration-300 ease-in-out focus:ring-2 focus:ring-offset-2 focus:outline-none"
        onBlur={handleBlur33}
        onClick={onClick}
        onFocus={handleFocus35}
        onMouseEnter={handleMouseEnter36}
        onMouseLeave={handleMouseLeave37}
        style={{
          height: "56px",
          paddingLeft: isHovered ? "20px" : "16px",
          paddingRight: isHovered ? "20px" : "16px",
          width: isHovered ? "auto" : "56px",
        }}
        type="button"
      >
        <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center">
          {icon}
        </span>
        {Boolean(isHovered) && (
          <span className="text-sm font-medium whitespace-nowrap">{label}</span>
        )}
      </button>
    </div>
  );
};
